export const DISCOUNT_UZP = 'uzp'
export const DISCOUNT_UZP_APPLICATION = 'uzp_application'
export const ALL_DISCOUNTS = [
  DISCOUNT_UZP,
  DISCOUNT_UZP_APPLICATION,
] as const

export type Discount = typeof ALL_DISCOUNTS[number]
